module.exports = __webpack_public_path__ + "c892cfd7b0e9f0dd61d5e5749b58cde6.png";